import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { Typography, Box, Alert, Link, CircularProgress } from '@mui/material';
import AuthLayout from '../components/AuthLayout';
import { registration } from '../services/api';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [state, setState] = useState('loading'); // loading | success | error
  const [supportContact, setSupportContact] = useState('');

  useEffect(() => {
    let cancelled = false;

    const verify = async () => {
      if (!token) {
        setState('error');
        return;
      }
      try {
        const response = await registration.verifyEmail(token);
        if (cancelled) return;
        setSupportContact(response.data?.support_contact || '');
        setState('success');
      } catch (err) {
        if (!cancelled) setState('error');
      }
    };

    verify();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <AuthLayout subtitle="Подтверждение почты">
      {state === 'loading' && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
          <CircularProgress sx={{ color: '#19C6C0' }} />
        </Box>
      )}

      {state === 'success' && (
        <>
          <Alert
            severity="success"
            sx={{
              borderRadius: '12px',
              background: 'rgba(191,243,227,0.4)',
              border: '1px solid rgba(0,168,120,0.2)',
              color: '#00A878',
              '& .MuiAlert-icon': { color: '#00A878' },
            }}
          >
            Почта подтверждена.
          </Alert>
          <Typography sx={{ mt: 2.5, fontSize: '0.875rem', color: '#6B7280' }}>
            Теперь в разделе «Тарифы» можно получить бесплатный доступ или выбрать тариф.
            {supportContact && (
              <>
                {' '}Свяжитесь с администратором: <b>{supportContact}</b>
              </>
            )}
          </Typography>
        </>
      )}

      {state === 'error' && (
        <Alert
          severity="error"
          sx={{
            borderRadius: '12px',
            background: 'rgba(246,193,195,0.3)',
            border: '1px solid rgba(217,79,92,0.2)',
            color: '#D94F5C',
            '& .MuiAlert-icon': { color: '#D94F5C' },
          }}
        >
          Ссылка недействительна или истекла. Войдите и введите код подтверждения в разделе «Настройки».
        </Alert>
      )}

      <Typography sx={{ mt: 3, textAlign: 'center', fontSize: '0.875rem', color: '#6B7280' }}>
        <Link component={RouterLink} to="/login" sx={{ fontWeight: 600, color: '#11BDB6' }}>
          Перейти ко входу
        </Link>
      </Typography>
    </AuthLayout>
  );
};

export default VerifyEmailPage;
